// extracted by mini-css-extract-plugin
module.exports = {"container":"propertiesFaq_container__1HLa6","title":"propertiesFaq_title__1Y11Z","answer":"propertiesFaq_answer__2IBAY"};
    if(module.hot) {
      // 1790670297977
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  